export default __webpack_public_path__ + "static/media/pen.9426324c.svg";